module.exports = __webpack_public_path__ + "static/img/nodata02@2x.c220ef61.png";